import { render } from "./LoadingIcon.vue?vue&type=template&id=72479d13&scoped=true"
const script = {}

import "./LoadingIcon.vue?vue&type=style&index=0&id=72479d13&lang=scss&scoped=true"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72479d13"]])

export default __exports__